import CryptoJS from "crypto-js";

const SECRET_KEY = CryptoJS.enc.Utf8.parse("abc1234567890123");

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  ).toString();
};